import React, { useEffect, useRef, useState } from "react";
import Barcode from 'react-barcode';
import {
    Page,
    Text,
    View,
    Document,
    Image,
    StyleSheet,
    BlobProvider,
    PDFDownloadLink,
    Svg,
    Font,
    Line,
} from "@react-pdf/renderer";
import { CNPJMask, CPFMask } from "@/app/core/util/helpers/UserHelper";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { OnlyDateTranslate } from "@/app/core/util/DateTranslater";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";

import JsBarcode from "jsbarcode";

export default function Etiqueta({ delivery }) {
    const [myDoc, setMyDoc] = useState(null);

    const styles = StyleSheet.create({
        body: {
            paddingTop: 5,
            paddingBottom: 65,
            paddingHorizontal: 35,
        },
        title: {
            fontSize: 24,
            textAlign: "center",
            // fontFamily: "Times-Roman",
        },
        author: {
            fontSize: 12,
            textAlign: "center",
            marginTop: 10,
        },
        subtitle: {
            fontSize: 18,
            margin: 6,
            // fontFamily: "Times-Roman",
        },
        text: {
            margin: 8,
            fontSize: 12,
            textAlign: "justify",
            // fontFamily: "Times-Roman",
        },
        image: {
            marginVertical: 5,
            marginHorizontal: 215,
            width: 80,
            textAlign: "center",
        },
        header: {
            fontSize: 12,
            marginBottom: 10,
            textAlign: "center",
            color: "grey",
        },
        pageNumber: {
            position: "absolute",
            fontSize: 12,
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: "center",
            color: "grey",
        },
        table: {
            display: "table",
            width: "auto",
            borderStyle: "solid",
            borderWidth: 1,
            borderRightWidth: 0,
            borderBottomWidth: 0
        },
        tableRow: {
            margin: "auto",
            flexDirection: "row",
        },
        tableCol: {
            width: "16%",
            borderStyle: "solid",
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0
        },
        tableCell: {
            margin: "auto",
            marginTop: 5,
            fontSize: 10
        },
        col: {
            width: "50%",
            borderStyle: "solid",
            borderWidth: 1,
        }
    });

    // const encodeSvg = reactElement => {
    //     return (
    //         'data:image/png;base64,' +
    //         escape(ReactDOMServer.renderToStaticMarkup(reactElement))
    //     );
    // };


    useEffect(() => {
        if (delivery && delivery.id) {
            createContract();
        }
    }, [delivery]);

    function getImgBase64String(value) {
        console.log("Código de barras", value)
        const barcodeNode = document.getElementById('barcode');
        JsBarcode(barcodeNode, value, { displayValue: false });
        console.log("Código de barras", barcodeNode, barcodeNode.src)
        return barcodeNode.src;
    }

    function createContract() {
        setMyDoc(
            <Document>
                <Page style={styles.body} orientation="landscape">
                    <Svg height="10" width="800">
                        <Line
                            x1="0"
                            y1="0"
                            x2="850"
                            y2="0"
                            strokeWidth={2}
                            stroke="rgb(0,0,0)"
                        />
                    </Svg>
                    <Text style={styles.subtitle}>
                        Total Express
                    </Text>
                    <View style={styles.tableRow}>
                        <View style={styles.col}>
                            <Text style={styles.text}>
                                Dent : {delivery && delivery.destination && delivery.destination.name}
                            </Text>
                            <Text style={styles.text}>
                                Endereço: {delivery && delivery.destination && `${delivery.destination.number}, ${delivery.destination.street}, ${delivery.destination.neighborhood}`}
                            </Text>
                            <Text style={styles.text}>
                                Cidade: {delivery && delivery.destination && `${delivery.destination.city} - ${delivery.destination.state}`}
                            </Text>
                            <Text style={styles.text}>
                                CEP: {delivery && delivery.destination && `${delivery.destination.zipCode}`}
                            </Text>
                        </View>
                        <View style={styles.col}>
                            <Text style={styles.text}>
                                NF : {delivery && delivery.nfKey}
                            </Text>
                            <Text style={styles.text}>
                                Ped: {delivery && delivery.totalExpressStatus && delivery.totalExpressStatus.pedido}
                            </Text>
                            <Text style={styles.text}>
                                Vol: 1
                            </Text>
                            <Text style={styles.text}>
                                TP: 0
                            </Text>
                            <Text style={styles.text}>
                                DT: {delivery && OnlyDateTranslate(delivery.createdAt)}
                            </Text>
                            <Text style={styles.text}>
                                KG: {delivery && DeliveryHelper().TotalDeclaredWeight(delivery)}
                            </Text>
                            <Text style={styles.text}>
                                Peça: 1 / 1
                            </Text>
                        </View>
                    </View>
                    <Svg height="10" width="800">
                        <Line
                            x1="0"
                            y1="0"
                            x2="850"
                            y2="0"
                            strokeWidth={2}
                            stroke="rgb(0,0,0)"
                        />
                    </Svg>


                    <View>
                        <Text style={styles.title}>
                            {delivery && delivery.totalExpressStatus && `${delivery.totalExpressStatus.rota}`}
                        </Text>
                        <Image src={() => getImgBase64String(delivery.awb)} style={{ width: '350px', height: '100px', textAlign: "center", }} />
                    </View>
                    <Text
                        style={styles.pageNumber}
                        render={({ pageNumber, totalPages }) =>
                            `${pageNumber} / ${totalPages}`
                        }
                        fixed
                    />
                </Page>
            </Document>
        );
    }

    return (
        <div>
            {delivery && myDoc && (
                <BlobProvider document={myDoc}>
                    {({ blob, url, loading, error }) => (
                        <a className="block block-fx-pop block-bordered border-success mt-1"
                            href={url}
                            onClick={() => {
                                console.log("erro", error, loading, url, blob, myDoc);
                            }}
                            target="_blank">
                            <div className="block-header">
                                <div className="block-title">
                                    <i className="far fa-file-pdf text-success mr-2" /> Etiqueta
                                </div>
                                <div className="block-tools">
                                    <a className="btn btn-hero-success btn-sm" href={url} target="_blank"><i className="si si-cloud-download mr-1" /> Baixar</a>
                                </div>
                            </div>
                        </a>
                    )}
                </BlobProvider>
            )}
            <div style={{ display: 'none' }}>
                <img id="barcode" />
            </div>
        </div>
    );
}
